import PropTypes from "prop-types";
import { styled, useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import MainCard from "components/common/card/MainCard";
import TotalIncomeCard from "components/cards/income/TotalIncomeCard.component";
import { IconInfoCircle } from "@tabler/icons";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";


const WeatherCard = (props) => {
  const {
    isLoading,
    label,
    min,
    max,
    icon,
    mean,
    bgColor,
    avatarcolor,
    trend,
    height = 53,
    onClickCard = () => { }
  } = props
  const theme = useTheme();
  const { t } = useTranslation()
  const { pathname } = useLocation()

  return (
    <>
      {isLoading ? (
        <TotalIncomeCard />
      ) : (
        <CardWrapper
          border={false}
          content={false}
          bgcolor={bgColor}
          avatarcolor={avatarcolor}
          height={height}
        >
          <Grid
            onClick={pathname !== '/dashboard/data-sensors/metrics' ? () => onClickCard() : null}
            container
            sx={{
              display: "flex",
              alignItems: "center",
              pl: 1, pr: 1, pt: (min && max) ? 1 : 0,
              justifyContent: "space-between",
              height: '100%',
              cursor: pathname !== '/dashboard/data-sensors/metrics' ? 'pointer' : 'default'
            }}
          >
            <Grid
              item
              xs={8.5}
              container
              spacing={0.5}
              display="flex"
              alignItems={trend ? 'center' : "start"}
            >
              <Grid item  >
                <Avatar
                  variant="rounded"
                  sx={{

                    [theme.breakpoints.down("md")]: {
                      ...theme.typography.smallAvatar,
                    },
                    [theme.breakpoints.up("md")]: {
                      ...theme.typography.mediumAvatar,
                    },
                    ...theme.typography.commonAvatar,
                    backgroundColor: `${avatarcolor}`,
                    color: "#fff",
                    cursor: pathname !== '/dashboard/data-sensors/metrics' ? 'pointer' : 'default'

                  }}

                >
                  {icon}
                </Avatar>
              </Grid>

              <Grid item mt={mean !== t('Absent data') ? 0 : 0.7}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    color: "white",
                    fontWeight: 500
                  }}
                >
                  {t(label)}
                </Typography>
                {min && min !== null && max && max !== null && (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start",
                      }}
                    >
                      <Typography sx={{ fontSize: 10, color: avatarcolor, pb: 0.2 }} align="left" >
                        Min
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: avatarcolor, marginBottom: 2, marginTop: -0.8, fontSize: 12 }}
                        align="left"
                      >
                        {`${min} - `}
                      </Typography>


                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "start",
                      }}
                    >
                      <Typography sx={{ fontSize: 10, color: avatarcolor, pl: 0.5, pb: 0.2 }} align="left" >
                        Max
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ color: avatarcolor, mt: 0.15, pl: 0.5, marginBottom: 2, marginTop: -0.8, fontSize: 12 }}
                        align="left"
                      >
                        {max}
                      </Typography>


                    </Box>
                  </Box>
                )}

                {trend && (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        color: avatarcolor,
                        mt: 0.25,
                        fontSize: 11,
                      }}
                    >
                      {trend}
                    </Typography>

                    <Tooltip title={t('Trend of the last 60 minutes')}>
                      <IconButton sx={{ p: 0, pl: 0.5 }}>
                        <IconInfoCircle
                          style={{ color: avatarcolor, width: 16, height: 16 }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}
              </Grid>
            </Grid>

            {mean && mean !== null && mean !== undefined && (
              <Grid
                item
                xs={3.5}
                sx={{
                  zIndex: 20,
                  display: "flex",
                  justifyContent: "end",
                  //flexDirection: "column",
                  alignItems: 'center'
                }}
              >
                <Box sx={{ height: '100%', marginTop: mean !== t('Absent data') ? 0 : 2 }}>
                  {mean !== t('Absent data') &&
                    <Typography
                      sx={{
                        fontSize: 10,
                        color: avatarcolor,
                        //       marginTop:  0.5,
                      }}
                      align={"right"}
                    >
                      {t('Average')}
                    </Typography>}

                  <Typography
                    sx={{
                      fontSize: mean === t('Absent data') ? 11 : 13.5,
                      fontWeight: "bold",
                      color: "white",
                      marginBottom: trend ? 0 : 2,
                      marginTop: 0,
                    }}
                    align="center"
                  >
                    {mean}
                  </Typography>
                </Box>

              </Grid>
            )}
          </Grid>
        </CardWrapper>
      )}
    </>
  );
};

WeatherCard.propTypes = {
  props: PropTypes.object,
};

export default WeatherCard;

// styles
const CardWrapper = styled(MainCard)(
  ({ theme, bgcolor, avatarcolor, height }) => ({
    display: "flex",
    alignItems: "center",
    height: height,
    //minWidth:266,
    backgroundColor: bgcolor,
    color: theme.palette.primary.light,
    overflow: "hidden",
    position: "relative",
    boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 100,
      background: `linear-gradient(210.04deg, ${avatarcolor} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      borderRadius: "50%",
      top: -15,
      right: -180,
      zIndex: 10,
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 100,
      background: `linear-gradient(140.9deg, ${avatarcolor} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      borderRadius: "50%",
      top: -70,
      right: -130,
      zIndex: 10,
    },
  })
);

